import React, {Component} from 'react'
import propTypes from 'prop-types'
import InfoIcon from '@material-ui/icons/Info'
import WarningIcon from '@material-ui/icons/Warning'
import ErrorIcon from '@material-ui/icons/Error'
import {DialogMessageType} from './dialogMessageType'
import {prefix} from 'helpers/component'
import './dialogMessage.scss'

class DialogMessage extends Component {
  constructor(props) {
    super(props)
    this.getClass = prefix('dialogMessage-')
  }

  getIcon = (type) => {
    switch (type) {
      case DialogMessageType.INFO:
        return <InfoIcon/>
      case DialogMessageType.WARNING:
        return <WarningIcon/>
      case DialogMessageType.ERROR:
        return <ErrorIcon/>
      default:
        return <InfoIcon/>
    }
  }

  render() {
    const {type, show, children} = this.props

    const showClassName = show ? 'show' : 'hide'

    return (
      <div className={this.getClass(['container', type.toLowerCase(), showClassName])}>
        <div className={this.getClass('icon')}>
          {this.getIcon(type)}
        </div>
        <div className={this.getClass('content')}>
          {children}
        </div>
      </div>
    )
  }
}

DialogMessage.propTypes = {
  children: propTypes.any,
  show: propTypes.bool.isRequired,
  type: propTypes.string.isRequired,
}

DialogMessage.defaultProps = {
  show: true,
  type: DialogMessageType.INFO,
}

export default DialogMessage
